<!-- src/App.vue -->
<template>
  <div id="app">
    <router-view />
    <footer class="app-footer">
      <CopyrightFooter />
    </footer>
  </div>
</template>

<script>
import CopyrightFooter from "@/components/GenericComponents/CopyrightFooter.vue";

export default {
  name: "App",
  components: {
    CopyrightFooter,
  },
};
</script>

<style>
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app-footer {
  margin-top: auto;
  width: 100%;
}
/* Hide global footer when an overlay (password, legal, intro) is active */
body.overlay-active .app-footer {
  display: none;
}
</style>
